import { render, staticRenderFns } from "./PublicTokens.vue?vue&type=template&id=3c0de0f4&scoped=true&"
import script from "./PublicTokens.vue?vue&type=script&lang=js&"
export * from "./PublicTokens.vue?vue&type=script&lang=js&"
import style0 from "./PublicTokens.vue?vue&type=style&index=0&id=3c0de0f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0de0f4",
  null
  
)

export default component.exports